var map = {
	"./DEPOIS.jpg": "6e92",
	"./ENLATADOS.jpg": "e44e",
	"./IMG_0095.jpg": "77ec",
	"./IMG_3235.jpg": "bd25",
	"./IMG_4414.jpg": "99cd",
	"./MORANGO-NA-COLHER.jpg": "a1ce",
	"./PORT07.jpg": "d52e",
	"./PORT10.jpg": "2b45",
	"./PORT13.jpg": "9577"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ad3";